// src/lib/activityLog.js
// Meldet Nutzungszeit für das Admin-Dashboard (Tabelle user_activity, RPC log_activity,
// SQL in scripts/create-user-activity.sql). Pro Bereich höchstens eine Meldung pro Minute;
// der Server zählt daraus „aktive Minuten“ pro Tag.
// Fehlt die Funktion in Supabase oder schlägt sie fehl, wird das Melden für diese
// Sitzung abgeschaltet – die App läuft normal weiter.

import { supabase } from "../supabaseClient";

const THROTTLE_MS = 60 * 1000;
const lastLogged = {};
let disabled = false;

function localDay(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// Nur abschalten, wenn Funktion/Tabelle in Supabase fehlen – bei Netzwerk- oder
// sonstigen Fehlern beim nächsten Mal erneut versuchen
const MISSING_CODES = ["PGRST202", "PGRST205", "42883", "42P01"];

export function isMissingInSupabase(error) {
  return !!error && MISSING_CODES.includes(error.code);
}

export async function logActivity(area, languageId) {
  if (disabled || !area) return;
  const now = Date.now();
  if (lastLogged[area] && now - lastLogged[area] < THROTTLE_MS) return;
  lastLogged[area] = now;

  try {
    const { error } = await supabase.rpc("log_activity", {
      p_day: localDay(),
      p_area: area,
      p_language_id: languageId || null,
    });
    if (isMissingInSupabase(error)) {
      disabled = true;
      console.warn("logActivity disabled:", error.message || error);
    } else if (error) {
      // diese Minute nicht gezählt, nächste Eingabe versucht es wieder
      lastLogged[area] = 0;
      console.warn("logActivity failed:", error.message || error);
    }
  } catch (e) {
    lastLogged[area] = 0;
    console.warn("logActivity failed:", e);
  }
}
